export const LINKS = {
    ZOCDOC: "https://www.zocdoc.com/wl/myorcare/search",
    CLINIKO: "https://myor-diagnostics-ltd.au2.cliniko.com/bookings?embedded=true",
    CLIENT_SECURE: "https://myordietetics.clientsecure.me/request/service",
    CLIENT_DIRECTORY: "https://www.myorthrive.com/directory",
    APPOINTMENT: "/appointment"
}